import { ListSortDirection } from '../enums/list-sort-direction.enum';
import { Status } from '../enums/status.enum';

export class FilterModel {
  constructor(
    public page: number | 0,
    public pageSize: number | 10,
    public search?: string | null,
    public sortField?: string | null,
    public sortOrder?: ListSortDirection | ListSortDirection.Ascending,
    public status?: Status | Status.Active,
    public parent?: number | null,
  ) {
    page = 0;
    pageSize = 5;
  }
}
